import { TeamsClient, TeamDto } from '../web-api-client';
import { API_CONFIG } from '../config/api';

class TeamsService {
  private teamsCache: TeamDto[] | null = null;
  private cacheTimestamp: number = 0;
  private readonly CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

  async getTeams(): Promise<TeamDto[]> {
    // Check if cache is still valid
    if (this.teamsCache && (Date.now() - this.cacheTimestamp) < this.CACHE_DURATION) {
      return this.teamsCache;
    }

    const client = new TeamsClient(API_CONFIG.baseUrl);
    const teams = await client.getTeams();

    this.teamsCache = teams;
    this.cacheTimestamp = Date.now();
    return teams;
  }

  async getTeamById(teamId: number): Promise<TeamDto | null> {
    if (!teamId) return null;

    try {
      const teams = await this.getTeams();
      return teams.find(t => t.id === teamId) || null;
    } catch (error) {
      console.error('Failed to find team by ID:', error);
      return null;
    }
  }

  // Clear cache manually if needed
  clearCache(): void {
    this.teamsCache = null;
    this.cacheTimestamp = 0;
  }
}

export const teamsService = new TeamsService();
